/**
 * FuelPriceEditor — Modal/inline editor for fuel prices
 */

import { NumberInput, Stack, Group, Button, Text, Badge } from '@mantine/core';
import type { FuelPrice, FuelVariantId } from '../types/heatingCost.types';
import { FUEL_VARIANTS } from '../constants/fuelDefaults';

interface FuelPriceEditorProps {
  prices: FuelPrice[];
  onUpdatePrice: (variantId: FuelVariantId, price: number) => void;
  onReset: () => void;
}

export function FuelPriceEditor({ prices, onUpdatePrice, onReset }: FuelPriceEditorProps) {
  const hasModified = prices.some(p => p.isUserModified);

  return (
    <Stack gap="sm">
      <Group justify="space-between">
        <Text size="sm" fw={500}>Edycja cen paliw</Text>
        {hasModified && (
          <Button size="xs" variant="subtle" color="gray" onClick={onReset}>
            Przywróć domyślne
          </Button>
        )}
      </Group>
      {prices.map(price => {
        const variant = FUEL_VARIANTS[price.variantId];
        return (
          <Group key={price.variantId} gap="xs" wrap="nowrap">
            <Text size="xs" style={{ flex: 1, minWidth: 180 }}>
              {variant.label} — {variant.boilerType}
              {price.isUserModified && (
                <Badge size="xs" ml={4} color="orange" variant="light">zmieniona</Badge>
              )}
            </Text>
            <NumberInput
              size="xs"
              value={price.pricePerUnit}
              onChange={(val) => {
                if (typeof val === 'number' && val >= 0) {
                  onUpdatePrice(price.variantId, val);
                }
              }}
              min={0}
              decimalScale={4}
              step={0.01}
              style={{ width: 120 }}
              rightSection={<Text size="xs" c="dimmed">{price.priceUnit.replace('zł/', '')}</Text>}
            />
          </Group>
        );
      })}
    </Stack>
  );
}
